import { render, staticRenderFns } from "./OtpView.vue?vue&type=template&id=ef7c8e6e&scoped=true"
import script from "./OtpView.vue?vue&type=script&lang=js"
export * from "./OtpView.vue?vue&type=script&lang=js"
import style0 from "./OtpView.vue?vue&type=style&index=0&id=ef7c8e6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef7c8e6e",
  null
  
)

export default component.exports